import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { readReturnUrl } from 'src/tools/returnUrl';

const PublicOnlyRoute = ({ children }) => {
	const authUser = useSelector((state) => state.auth.authUser);
	const location = useLocation();

	if (authUser) {
		return <Navigate to={readReturnUrl(location.search)} replace />;
	}

	return children;
};

export default PublicOnlyRoute;
